import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { DialogRoute } from 'src/components/shared/routes/DialogRoute';
import { DeleteHistorySucceededDialog } from '../../common/DeleteHistorySucceededDialog';
import { OptionalDeleteHistoryDialog } from './OptionalDeleteHistoryDialog';
import { ReportFailedDialog } from './ReportFailedDialog';
import { ReportMenuDialog } from './ReportMenuDialog';
import { ReportSelectConst } from './ReportSelectConst';
import { ReportSucceededDialog } from './ReportSucceededDialog';
import { ResortReportForm } from './ResortReportForm';

export const ResortReportRouting: React.FC = () => {
  const routeMatch = useRouteMatch();
  if (!routeMatch) {
    return null;
  }

  const basePath = routeMatch.path;
  const baseUrl = routeMatch.url;

  return (
    <>
      <Route path={`${basePath}/report`}>
        <ResortReportForm basePath={baseUrl} />
      </Route>
      <DialogRoute path={`${basePath}/menu`}>
        <ReportMenuDialog basePath={baseUrl} />
      </DialogRoute>
      <Route path={`${basePath}/select-construction`}>
        <ReportSelectConst basePath={baseUrl} />
      </Route>
      <DialogRoute path={`${basePath}/report-succeeded`}>
        <ReportSucceededDialog basePath={baseUrl} />
      </DialogRoute>
      <DialogRoute path={`${basePath}/report/report-failed`}>
        <ReportFailedDialog />
      </DialogRoute>
      <DialogRoute path={`${basePath}/history-delete`}>
        <OptionalDeleteHistoryDialog basePath={baseUrl} />
      </DialogRoute>
      <DialogRoute path={`${basePath}/history-delete-succeeded`}>
        <DeleteHistorySucceededDialog />
      </DialogRoute>
    </>
  );
};
